var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crumbs-page"},[(_vm.title || _vm.routeName)?_c('div',{staticClass:"crumbs-title"},[_vm._t("header",function(){return [_c('span',[_vm._v(_vm._s(_vm.title || _vm.routeName))])]})],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }